import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { FileUploaderContext } from "./file-upload-provider";

// Hook to get the current status of all file uploads
export const useFileUploadStatus = () => {
  const $ = _c(2);
  const context = useContext(FileUploaderContext);
  if (context === undefined) {
    throw new Error("useFileUploadStatus must be used within a FileUploadProvider");
  }
  const {
    items
  } = context;
  let t0;
  if ($[0] !== items) {
    t0 = {
      items
    };
    $[0] = items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};